import useAPICall from "../../../hooks/useAPICall";
import en from "../../../Lang/en.json";
import { GET_STATUS } from '../../../utilities/apis'

const useGetUserStatus = () => {
  const [data, error, isLoading, callGetData, setSuccessData, setError] =
    useAPICall(undefined, undefined);

  const defaultFallback = () => {
    setError(en.something_went_wrong);
    setSuccessData(undefined);
  };

  const statusObj = [
    {
      status_code: "200",
      status_txt: "OK",
      callBack: (res) => {
        const data = res.data;
        if (data && typeof data === "object") {
          setSuccessData(res.data);
        } else {
          defaultFallback();
        }
      },
    },
    {
      status_txt: "Bad Request",
      status_code: "400",
      callBack: defaultFallback,
    },
    {
      status_txt: "Internal Server Error",
      status_code: 500,
      callBack: defaultFallback
    }
  ];

  const getUserStatus = () => {
    const url = `${process.env.REACT_APP_API_URL}${GET_STATUS}`;
    callGetData({
      url,
      method: "GET",
      statusObj,
      defaultFallback,
    });
  };
  return [data, error, isLoading, getUserStatus, setSuccessData, setError];
};

export default useGetUserStatus;
